import { render } from "./KontoEroeffnung.vue?vue&type=template&id=0e663f70"
import script from "./KontoEroeffnung.vue?vue&type=script&lang=js"
export * from "./KontoEroeffnung.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__